export class ColumnArraryModel {
    id?: any;
    columnName?: any;
    docPath?: any;
    docName?: any;
    isSelected = false;
}
